import { createFileRoute } from "@tanstack/react-router";
import CardPageSettings from "@/pages/admin/CardPageSettings";

export const Route = createFileRoute("/admin/card-page-settings")({
  component: CardPageSettings,
});
